<template>
  <owa-modal-frame
    title="Cancel Subscription?"
    has-actions
    :is-showing="isShowing"
    @close-modal="$emit('close-modal')"
  >
    <p>
      You can continue to use all of the icons, features, and services your subscription provides up until your subscription ends on
      <strong>
        <time :datetime="subscription.periodEndAt">{{ periodEndAtDate }}</time> </strong
      >. But you'll lose access to&hellip;
    </p>

    <owa-subscription-features :is-showing-backer-perks="hasBackerSubscription" />

    <template slot="actions">
      <owa-action-button
        :is-processing="isProcessing"
        icon-name="faBan"
        is-processing-label="Cancelling Subscription..."
        label="Cancel Subscription"
        theme="danger"
        @click="cancelSubscription"
      />
    </template>
  </owa-modal-frame>
</template>

<script>
  import { mapActions } from 'vuex'
  import get from 'lodash/get'
  import moment from 'moment'
  import { ModalFrameMixin } from 'app/components-wa/modals/ModalFrame'

  export default {
    name: 'ModalCancelSubscription',

    mixins: [ModalFrameMixin],

    props: {
      subscription: {
        type: Object,
        required: true
      }
    },

    data() {
      return {
        isProcessing: false
      }
    },

    computed: {
      hasBackerSubscription() {
        return 'FA-BACKER' === get(this, ['$account', 'subscription', 'plan', 'sku'])
      },

      periodEndAtDate() {
        return moment.utc(this.subscription.periodEndAt).format('MMMM D, YYYY')
      }
    },

    methods: {
      ...mapActions('flashMessages', ['addFlashMessage']),

      ...mapActions('subscriptions', ['cancelAtPeriodEnd']),

      async cancelSubscription() {
        this.isProcessing = true

        try {
          await this.cancelAtPeriodEnd(true)

          this.addFlashMessage({
            message: {
              title: 'No Auto-Renew For You!',
              content: `As you asked, we won't auto-renew your subscription when it expires on ${this.periodEndAtDate}.  You'll get all of our updates, services, and goodies your subscription offers until then. If you change your mind, you can always set your subscription to auto-renew again.`,
              iconName: 'faCheck',
              theme: 'success',
              styleOverride: { '--message-background': 'var(--green1);' }
            },
            topic: 'details:section'
          })
        } catch (err) {
          this.flashError()
        }

        this.isProcessing = false
        this.$emit('close-modal')
      },

      flashError() {
        this.addFlashMessage({
          message: {
            content: 'Ut oh! Something went wrong.',
            theme: 'danger',
            iconName: 'faSkullCrossbones',
            getHelp: true
          }
        })
      }
    }
  }
</script>
